export const endpoints: {
  callsPerMonth?: number
  costPerCall?: number
  costPerCompany?: number
  id: ApiEndpointId
  isNew?: boolean
  loc: string
  method: ApiEndpointMethodMethod
  noVersion?: boolean
  path: string
  text: string
  versions: ApiVersion[]
}[] = [
  {
    id: 'actions-request-action',
    loc: '/api/request-action',
    method: 'POST',
    path: '/actions',
    text: 'api.navigation.actions.endpoints.requestAction',
    versions: ['v2'],
  },
  {
    id: 'actions-fetch',
    loc: '/api/fetch-actions',
    method: 'GET',
    path: '/actions',
    text: 'api.navigation.actions.endpoints.fetchActions',
    versions: ['v2'],
  },
  {
    callsPerMonth: 22 * 1000000,
    costPerCompany: 1,
    id: 'companies-enrich-from-domain',
    loc: '/api/enrich-company-from-domain',
    method: 'GET',
    path: '/companies/:domain',
    text: 'api.navigation.companies.endpoints.enrichFromDomain',
    versions: ['v1', 'v2'],
  },
  {
    callsPerMonth: 6 * 1000000,
    costPerCompany: 1,
    id: 'companies-enrich-from-email',
    isNew: true,
    loc: '/api/enrich-company-from-email',
    method: 'GET',
    path: '/companies/by-email',
    text: 'api.navigation.companies.endpoints.enrichFromEmail',
    versions: ['v2'],
  },
  {
    callsPerMonth: 13 * 1000000,
    costPerCompany: 1,
    id: 'companies-enrich-from-social-network-url',
    loc: '/api/enrich-company-from-social-network-url',
    method: 'GET',
    path: '/companies/by-social',
    text: 'api.navigation.companies.endpoints.enrichFromSocialNetworkUrl',
    versions: ['v1', 'v2'],
  },
  {
    id: 'companies-count',
    loc: '/api/count-companies',
    method: 'GET',
    path: '/companies/count',
    text: 'api.navigation.companies.endpoints.count',
    versions: ['v1', 'v2'],
  },
  {
    callsPerMonth: 3 * 1000000,
    costPerCompany: 1,
    id: 'companies-search',
    loc: '/api/search-companies',
    method: 'GET',
    path: '/companies',
    text: 'api.navigation.companies.endpoints.search',
    versions: ['v1', 'v2'],
  },
  {
    callsPerMonth: 5 * 1000000,
    costPerCompany: 1,
    id: 'companies-search-name',
    loc: '/api/search-companies-name',
    method: 'GET',
    path: '/companies/by-name',
    text: 'api.navigation.companies.endpoints.searchByName',
    versions: ['v1', 'v2'],
  },
  {
    callsPerMonth: 400000,
    costPerCompany: 1,
    id: 'companies-search-prompt',
    isNew: true,
    loc: '/api/search-companies-prompt',
    method: 'GET',
    path: '/companies/by-prompt',
    text: 'api.navigation.companies.endpoints.searchByPrompt',
    versions: ['v2'],
  },
  {
    callsPerMonth: 1000000,
    costPerCompany: 1,
    id: 'companies-search-similar',
    loc: '/api/search-similar-companies',
    method: 'GET',
    path: '/companies/similar',
    text: 'api.navigation.companies.endpoints.searchSimilar',
    versions: ['v1', 'v2'],
  },
  {
    callsPerMonth: 100000,
    costPerCall: 10,
    id: 'companies-ask',
    isNew: true,
    loc: '/api/ask-company',
    method: 'POST',
    path: '/companies/:domain/ask',
    text: 'api.navigation.companies.endpoints.ask',
    versions: ['v2'],
  },
  {
    callsPerMonth: 2 * 1000000,
    costPerCompany: 10,
    id: 'companies-fetch-context',
    isNew: true,
    loc: '/api/fetch-company-context',
    method: 'GET',
    path: '/companies/:domain/context',
    text: 'api.navigation.companies.endpoints.fetchContext',
    versions: ['v2'],
  },
  {
    callsPerMonth: 1 * 100_000,
    costPerCompany: 1,
    id: 'companies-fetch-email-patterns',
    loc: '/api/fetch-company-email-patterns',
    method: 'GET',
    path: '/companies/:domain/email-patterns',
    text: 'api.navigation.companies.endpoints.findEmailPatterns',
    versions: ['v1', 'v2'],
  },
  {
    callsPerMonth: 1 * 100_000,
    costPerCompany: 1,
    id: 'companies-analytics-fetch',
    isNew: true,
    loc: '/api/fetch-companies-analytics',
    method: 'GET',
    path: '/companies/analytics',
    text: 'api.navigation.companies.endpoints.fetchAnalytics',
    versions: ['v2'],
  },
  {
    callsPerMonth: 1 * 100_000,
    costPerCompany: 1,
    id: 'companies-analytics-export',
    isNew: true,
    loc: '/api/export-companies-analytics',
    method: 'GET',
    path: '/companies/analytics/export',
    text: 'api.navigation.companies.endpoints.exportAnalytics',
    versions: ['v2'],
  },
  {
    callsPerMonth: 1 * 10_000,
    id: 'industries-search',
    loc: '/api/search-industries',
    method: 'GET',
    path: '/industries',
    text: 'api.navigation.industries.endpoints.search',
    versions: ['v1', 'v2'],
  },
  {
    callsPerMonth: 1 * 10_000,
    id: 'industries-find-similar',
    loc: '/api/find-similar-industries',
    method: 'GET',
    path: '/industries/similar',
    text: 'api.navigation.industries.endpoints.findSimilar',
    versions: ['v1', 'v2'],
  },
  {
    id: 'job-titles-enrich-from-name',
    loc: '/api/enrich-job-title-from-name',
    method: 'GET',
    path: '/job-titles/enrich',
    text: 'api.navigation.jobTitles.endpoints.enrich',
    versions: ['v1', 'v2'],
  },
  {
    id: 'lists-fetch-lists',
    loc: '/api/fetch-lists',
    method: 'GET',
    path: '/lists',
    text: 'api.navigation.lists.endpoints.fetchLists',
    versions: ['v1', 'v2'],
  },
  {
    id: 'lists-create-list',
    loc: '/api/create-list',
    method: 'POST',
    path: '/lists',
    text: 'api.navigation.lists.endpoints.createList',
    versions: ['v1', 'v2'],
  },
  {
    id: 'lists-fetch-companies',
    loc: '/api/fetch-companies-in-list',
    method: 'GET',
    path: '/lists/:listId/companies',
    text: 'api.navigation.lists.endpoints.fetchCompanies',
    versions: ['v1', 'v2'],
  },
  {
    id: 'lists-toggle-companies',
    loc: '/api/toggle-companies-in-list',
    method: 'PATCH',
    path: '/lists/:listId/companies/toggle',
    text: 'api.navigation.lists.endpoints.toggleCompanies',
    versions: ['v2'],
  },
  {
    id: 'locations-search-cities',
    loc: '/api/search-cities',
    method: 'GET',
    path: '/locations/cities',
    text: 'api.navigation.locations.endpoints.searchCities',
    versions: ['v1', 'v2'],
  },
  {
    id: 'locations-search-counties',
    loc: '/api/search-counties',
    method: 'GET',
    path: '/locations/counties',
    text: 'api.navigation.locations.endpoints.searchCounties',
    versions: ['v1', 'v2'],
  },
  {
    id: 'locations-search-countries',
    loc: '/api/search-countries',
    method: 'GET',
    path: '/locations/countries',
    text: 'api.navigation.locations.endpoints.searchCountries',
    versions: ['v1', 'v2'],
  },
  {
    id: 'locations-search-states',
    loc: '/api/search-states',
    method: 'GET',
    path: '/locations/states',
    text: 'api.navigation.locations.endpoints.searchStates',
    versions: ['v1', 'v2'],
  },
  {
    id: 'locations-search-continents',
    loc: '/api/search-continents',
    method: 'GET',
    path: '/locations/continents',
    text: 'api.navigation.locations.endpoints.searchContinents',
    versions: ['v1', 'v2'],
  },
  {
    id: 'teams-fetch-team',
    loc: '/api/fetch-team',
    method: 'GET',
    path: '/teams/:teamId',
    text: 'api.navigation.team.endpoints.fetchTeam',
    versions: ['v1', 'v2'],
  },
  {
    id: 'technologies-search',
    loc: '/api/search-technologies',
    method: 'GET',
    path: '/technologies',
    text: 'api.navigation.technologies.endpoints.search',
    versions: ['v1', 'v2'],
  },
  {
    id: 'utilities-fetch-api-health',
    loc: '/api/fetch-api-health',
    method: 'GET',
    noVersion: true,
    path: '/',
    text: 'api.navigation.utilities.endpoints.fetchApiHealth',
    versions: ['v2'],
  },
  {
    id: 'utilities-fetch-openapi',
    loc: '/api/fetch-openapi',
    method: 'GET',
    path: '/openapi',
    text: 'api.navigation.utilities.endpoints.fetchOpenApi',
    versions: ['v2'],
  },
]
